import type {
  ComplianceViolation,
  ComplianceViolationGetInput,
  ComplianceViolationGetSuccess,
  ComplianceViolationId,
} from '@terros/common'
import type { GetHookResponse } from '../../hooks'
import { useTantalimQuery } from '../../query'
import { complianceViolationKey } from '../../keys'

export function useComplianceViolation(violationId: ComplianceViolationId): GetHookResponse<ComplianceViolation> {
  return useTantalimQuery<ComplianceViolationGetInput, ComplianceViolationGetSuccess, ComplianceViolation>({
    url: '/compliance/violation/get',
    queryKey: complianceViolationKey(violationId),
    input: {
      violationId,
    },
    convertResponse: (data) => data.violation,
  })
}
